import { useTranslation } from 'react-i18next';

import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import FoldableCard from 'components/desktop/_general/Card/FoldableCard/FoldableCard';
import UnitWeightEditor from 'components/desktop/_general/UnitWeightEditor/UnitWeightEditor';
import { Characteristic } from 'enums/characteristic';
import { Optional } from 'functions/promiseExtensions';
import useCultureCode from 'hooks/redux/useCultureCode';
import { usePermissions } from 'hooks/usePermissions';
import * as Unit from 'types/BaseIngredient/Detail/Unit';
import * as UnitList from 'types/_general/Store/UnitList';

export const BaseIngredientUnitWeightsCard = ({
	state,
	handlers,
	data,
}: BaseIngredientTabProps): JSX.Element => {
	const { t } = useTranslation();
	const cultureCode: string = useCultureCode();

	const { isBaseIngredientEditor } = usePermissions();

	const getSuggestedUnitWeight = async (selectedUnit: Unit.Type): Promise<Optional<number>> => {
		const output: number = await Unit.getFromApiSuggested(
			selectedUnit,
			cultureCode,
			state.name,
			state.id,
			state.density,
			state.characteristic
		);
		return Optional.Just(output);
	};

	return (
		<FoldableCard
			defaultOpen={true}
			dataComponentType="baseingredient-weight-card"
			title={t('baseIngredient:WEIGHT')}
			content={
				<div className="card-body">
					<UnitWeightEditor
						units={UnitList.mapToUnitLightList(
							UnitList.getByCharacteristic(
								data.units,
								state.characteristic ?? Characteristic.SolidNonQuantifiable
							)
						)}
						unitWeights={state.unitWeights}
						setUnitWeights={handlers.setUnitWeights}
						disabled={!isBaseIngredientEditor}
						getSuggestedUnitWeight={getSuggestedUnitWeight}
						ai={true}
					/>
				</div>
			}
		/>
	);
};
